<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <div>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("username") }}</label>
                  <b-form-input
                    :placeholder="$t('username')"
                    v-model="Account.Username"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("displayName") }}</label>
                  <b-form-input
                    v-model="Account.DisplayName"
                    :placeholder="$t('displayName')"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("email") }}</label>
                  <b-form-input
                    :placeholder="$t('email')"
                    v-model="Account.Email"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("enableTwoFactor") }}</label>
                  <b-form-checkbox switch v-model="Account.EnableTwoFactor">
                  </b-form-checkbox>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("isActive") }}</label>
                  <b-form-checkbox switch v-model="Account.IsActive">
                  </b-form-checkbox>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("organization") }}</label>
                  <v-select
                    :options="OrganizationList"
                    :reduce="(item) => item.id"
                    :placeholder="$t('ChooseBelow')"
                    label="shortname"
                    v-model="Account.OrganizationID"
                    @input="ChangeOrganization"
                  ></v-select>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <!-- <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("organizationINN") }}</label>
                  <b-form-input
                    :placeholder="$t('organizationINN')"
                    v-model="Account.OrganizationINN"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col> -->
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("Password") }}</label>
                  <b-form-input
                    v-model="Account.Password"
                    :placeholder="$t('Password')"
                    type="password"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("ConfirmPassword") }}</label>
                  <b-form-input
                    :placeholder="$t('ConfirmPassword')"
                    v-model="Account.PasswordConfirm"
                    type="password"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("expirationDate") }}</label>
                  <date-picker
                    style="width:100%"
                    v-model="Account.ExpirationDate"
                    v-mask="'##.##.####'"
                    lang="ru"
                    :placeholder="$t('expirationdate')"
                    value-type="format"
                    format="DD.MM.YYYY"
                  />
                </div>
              </b-col>
              <!-- <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("lang") }}</label>
                  <b-form-input
                    :placeholder="$t('lang')"
                    v-model="Account.lang"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col> -->
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("mobileNumber") }}</label>
                  <b-form-input
                    v-model="Account.MobileNumber"
                    :placeholder="$t('mobileNumber')"
                    type="text"
                    v-mask="'9#-###-##-##'"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div class="p-1">
                  <label> {{ $t("role") }} </label>
                  <v-select
                    v-model="Account.Roles"
                    multiple
                    label="shortname"
                    :placeholder="$t('ChooseBelow')"
                    :options="RoleList"
                    :reduce="(item) => item.shortname"
                  />
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col class="text-left">
                <b-button
                  @click="$router.push('/managment/user')"
                  class="d-inline-block "
                  variant="danger"
                  ><i class="dripicons-arrow-thin-left"></i>
                  {{ $t("back") }}</b-button
                >
              </b-col>
              <b-col style="text-align: right !important; " class="text-right">
                <b-button
                  @click="SaveData"
                  class="d-inline-block "
                  variant="success"
                  ><i class="dripicons-checkmark"></i>
                  {{ $t("save") }}</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import vSelect from "vue-select";
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import OrganizationService from "@/services/others/organization.service";
import AccountService from "@/services/others/account.service";
import HelperService from "@/services/others/helper.service";
import Multiselect from "vue-multiselect";
export default {
  components: { Multiselect, Layout, PageHeader, vSelect, DatePicker },
  data() {
    return {
      title: this.$t("User"),
      braedcrumb: [
        {
          text: this.$t("Management"),
        },
        {
          text: this.$t("User"),
          active: true,
        },
      ],
      items: [],
      // //  show: false,
      Account: {},
      RoleList: [],
      filter: {
        oblastid: 0,
        regionid: 0,
        isfarmfy: false,
      },
      OrganizationList: [],
      lang: "ru",
    };
  },
  created() {
    this.lang = localStorage.getItem("locale") || "ru";
    this.show = true;
    HelperService.GetRoleList().then((res) => {
      this.RoleList = res.data;
    });
    OrganizationService.GetAll(
      this.filter.oblastid,
      this.filter.regionid,
      this.filter.isfarmfy
    ).then((res) => {
      this.OrganizationList = res.data;
    });
    AccountService.Get(this.$route.params.id)
      .then((res) => {
        this.show = false;
        this.Account = res.data;
      })
      .catch((error) => {
        this.$notification(error.response.data.error, "danger");
      });
  },
  directives: {},
  methods: {
    check() {
      if (
        this.Account.Username === 0 ||
        this.Account.Username === null ||
        this.Account.Username === undefined ||
        this.Account.Username === ""
      ) {
        this.$notification(this.$t("UsernameNotSelected"), "danger");
        return false;
      }
      if (
        this.Account.DisplayName === 0 ||
        this.Account.DisplayName === null ||
        this.Account.DisplayName === undefined ||
        this.Account.DisplayName === ""
      ) {
        this.$notification(this.$t("DisplayNameNotSelected"), "danger");
        return false;
      }
      if (
        this.Account.Email === 0 ||
        this.Account.Email === null ||
        this.Account.Email === undefined ||
        this.Account.Email === ""
      ) {
        this.$notification(this.$t("EmailNameNotSelected"), "danger");
        return false;
      }
      if (
        this.Account.EnableTwoFactor === 0 ||
        this.Account.EnableTwoFactor === null ||
        this.Account.EnableTwoFactor === undefined ||
        this.Account.EnableTwoFactor === ""
      ) {
        this.$notification(this.$t("EnableTwoFactorNotSelected"), "danger");
        return false;
      }
      if (
        this.Account.IsActive === 0 ||
        this.Account.IsActive === null ||
        this.Account.IsActive === undefined ||
        this.Account.IsActive === ""
      ) {
        this.$notification(this.$t("IsActiveNotSelected"), "danger");
        return false;
      }
      if (
        this.Account.OrganizationID === 0 ||
        this.Account.OrganizationID === null ||
        this.Account.OrganizationID === undefined ||
        this.Account.OrganizationID === ""
      ) {
        this.$notification(this.$t("OrganizationIDNotSelected"), "danger");
        return false;
      }
      // if (
      //   this.Account.OrganizationINN === 0 ||
      //   this.Account.OrganizationINN === null ||
      //   this.Account.OrganizationINN === undefined ||
      //   this.Account.OrganizationINN === ""
      // ) {
      //   this.$notification(this.$t("OrganizationINNNotSelected"), "danger");
      //   return false;
      // }
      if (
        this.Account.Password === 0 ||
        this.Account.Password === null ||
        this.Account.Password === undefined ||
        this.Account.Password === ""
      ) {
        this.$notification(this.$t("PasswordNotSelected"), "danger");
        return false;
      }
      if (
        this.Account.PasswordConfirm === 0 ||
        this.Account.PasswordConfirm === null ||
        this.Account.PasswordConfirm === undefined ||
        this.Account.PasswordConfirm === ""
      ) {
        this.$notification(this.$t("PasswordConfirmNotSelected"), "danger");
        return false;
      }
      if (
        this.Account.ExpirationDate === 0 ||
        this.Account.ExpirationDate === null ||
        this.Account.ExpirationDate === undefined ||
        this.Account.ExpirationDate === ""
      ) {
        this.$notification(this.$t("ExpirationDateNotSelected"), "danger");
        return false;
      }
      if (
        this.Account.MobileNumber === 0 ||
        this.Account.MobileNumber === null ||
        this.Account.MobileNumber === undefined ||
        this.Account.MobileNumber === ""
      ) {
        this.$notification(this.$t("MobileNumberNotSelected"), "danger");
        return false;
      }

      return true;
    },
    ChangeOrganization() {
      if (!!this.Account.organizationID) {
        this.Account.organizationName = this.OrganizationList.filter(
          (item) => this.Account.organizationID === item.id
        )[0].shortname;
      }
    },

    SaveData() {
      // if (!this.check()) {
      //   return false;
      // }
      AccountService.Update(this.Account)
        .then((res) => {
          this.$notification(this.$t("SaveSuccess"), "success");
          this.$router.push({ name: `user` });
        })
        .catch((err) => {
          this.$notification(this.$t(err.response.data.error), "danger");
        });
    },
  },
};
</script>

<style></style>
